var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-wrapper"},[_c('div',{ref:"articlceWrap",staticClass:"right-content scroll"},[_c('Article',{ref:"newsContent"})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }